import React from "react";
import cart from "../../images/shop.svg";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { GET_LAST_TRANSACTION } from "../../query/getLastTrans";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import moment from "moment";

const LastTransactions = ({ isPrint }) => {
  const { data } = useQuery(VIEW_PROFILE, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const {
    data: transData,
    loading: transLoading,
    error: transError,
  } = useQuery(GET_LAST_TRANSACTION, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      search_text: "%%",
      order_by: { created_at: "desc" },
      profile_id: localStorage.getItem("profile_id"),
      limit: 5,
    },
  });

  let getWeek = {
    0: "SUN",
    1: "MON",
    2: "TUE",
    3: "WED",
    4: "THU",
    5: "FRI",
    6: "SAT",
  };

  return (
    <div
      className="lastsubscription"
      style={
        isPrint
          ? {
              padding: "5%",
              borderRadius: "0px",
              width: "565px",
              height: "440px",
            }
          : {}
      }
    >
      <div
        className="title"
        style={
          isPrint
            ? {
                display: "inline-block",
              }
            : {}
        }
      >
        <h2
          style={
            isPrint
              ? { fontSize: "20px", fontWeight: "600", fontFamily: "Inter" }
              : {}
          }
        >
          Last Transactions
        </h2>
        {!isPrint && transData?.business_council_last_transactions?.length ? (
          <Link to="/transaction-details">view all</Link>
        ) : (
          ""
        )}
      </div>
      <ul
        className="lastsubscription-list"
        style={
          isPrint
            ? {
                display: "inline-block",
                listStyle: "none",
                marginTop: "4%",
                marginLeft: "-4%",
                width: "100%",
              }
            : {}
        }
      >
        {!transLoading
          ? transError
            ? "some error occurred..."
            : transData?.business_council_last_transactions?.length
            ? transData?.business_council_last_transactions?.map((item) => (
                <li style={isPrint ? { width: "100%", marginTop: "4%" } : {}}>
                  <div
                    className="col-left"
                    style={
                      isPrint
                        ? {
                            display: "inline-block",
                          }
                        : {}
                    }
                  >
                    {!isPrint ? (
                      <div className="icon">
                        <img src={cart} alt="cart" />
                      </div>
                    ) : (
                      <img
                        src={cart}
                        alt="cart"
                        style={
                          isPrint
                            ? { display: "inline-block", marginTop: "-10%" }
                            : {}
                        }
                      />
                    )}
                    <div
                      className="subscription-name"
                      style={
                        isPrint
                          ? {
                              display: "inline-block",
                              marginTop: "5%",
                              lineHeight: "5px",
                              marginLeft: "20px",
                            }
                          : {}
                      }
                    >
                      <p
                        style={
                          isPrint
                            ? {
                                color: "#161F3D",
                                fontFamily: "Inter",
                                fontWeight: "500",
                              }
                            : {}
                        }
                      >
                        {item?.full_name}
                      </p>
                      <label
                        style={
                          isPrint ? { color: "#989DB2", fontSize: "12px" } : {}
                        }
                      >
                        {item?.quantity} {item?.option_name} -
                        {getWeek[new Date(item?.created_at).getDay()]}{" "}
                        {moment(item?.created_at).format("DD MMM")}
                      </label>
                    </div>
                  </div>
                  <div
                    className="subscription-price"
                    style={
                      isPrint
                        ? {
                            display: "inline-block",
                            marginRight: "150px",
                            marginTop: "10px",
                            // position: "absolute",
                            float: "right",
                          }
                        : {}
                    }
                  >
                    <p
                      style={
                        isPrint ? { color: "#161F3D", fontWeight: "600" } : {}
                      }
                    >
                      $ {item?.purchased_price}
                    </p>
                  </div>
                </li>
              ))
            : !isPrint && "No Data Found..."
          : "Loading..."}
      </ul>
      {isPrint && !transData?.business_council_last_transactions?.length ? (
        <p style={{ marginTop: "5%" }}>No Data Found...</p>
      ) : (
        ""
      )}
    </div>
  );
};
export default LastTransactions;
